import clsx from "clsx";
import { TRACK_EVENTS } from "core/consts";
import { AnyObject } from "core/types";
import { RecareNameLogo } from "ds_legacy/components/RecareLogo";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { LARGE, dp } from "ds_legacy/materials/metrics";
import { Display } from "ds_legacy/materials/typography";
import { ReactNode, useEffect } from "react";
import { useTracking } from "react-tracking";
import { useTranslations } from "translations";
import Translations from "translations/types";

export default function ErrorPage({
  context,
  ErrorComponent,
  flex,
  getErrorLabel,
  pageName,
  reason,
  redirectTo,
}: {
  ErrorComponent?: ReactNode;
  context?: AnyObject;
  flex?: boolean;
  getErrorLabel?: (translations: Translations) => string;
  pageName?: string;
  reason?: string;
  redirectTo?: string;
}) {
  const translations = useTranslations();
  const { trackEvent } = useTracking();

  useEffect(() => {
    trackEvent({
      context,
      name: TRACK_EVENTS.ERROR_PAGE,
      page_name: pageName,
      reason,
      redirect_to: redirectTo,
    });
  }, []);
  const errorLabel = getErrorLabel?.(translations);

  if (ErrorComponent && errorLabel == null) return <>{ErrorComponent}</>;

  return (
    <div
      className={clsx(
        "box-border flex max-h-full max-w-full flex-1 flex-col items-center justify-center overflow-auto bg-primary-dark p-10 text-center",
        {
          "h-full w-full": flex,
          "h-screen w-screen": !flex,
        },
      )}
    >
      <RecareNameLogo size={LARGE} />
      <VerticalLayout maxWidth="80%">
        <Display light>
          {errorLabel ?? translations.general.status.error}
        </Display>
        {ErrorComponent && (
          <div style={{ marginTop: dp(30) }}>{ErrorComponent}</div>
        )}
      </VerticalLayout>
    </div>
  );
}
